import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { yachts } from '../data/mock';

const YachtsPage = () => {
  return (
    <div className="min-h-screen bg-gray-950">
      <Navbar />
      
      {/* Header */}
      <section className="pt-32 pb-16 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4">
            Our Luxury Fleet
          </h1>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Discover our collection of world-class yachts, each offering unparalleled luxury and performance
          </p>
        </div>
      </section>

      {/* Yachts Grid */}
      <section className="py-16 bg-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {yachts.map((yacht) => (
              <div
                key={yacht.id}
                className="group bg-gray-900 rounded-2xl overflow-hidden border border-gray-800 hover:border-orange-500/50 transition-all duration-300"
              >
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={yacht.image}
                    alt={yacht.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1.5 bg-gray-900/80 backdrop-blur-sm text-white text-sm font-medium rounded-lg">
                      {yacht.type}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-2xl font-serif font-bold text-white mb-2">{yacht.name}</h3>
                  <div className="flex items-center gap-2 text-white/60 text-sm mb-4">
                    <span>{yacht.length}</span>
                    <span className="text-orange-500">•</span>
                    <span>{yacht.guests} Guests</span>
                    <span className="text-orange-500">•</span>
                    <span>{yacht.crew} Crew</span>
                  </div>
                  <p className="text-white/70 text-sm leading-relaxed mb-6 line-clamp-3">
                    {yacht.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <div>
                      <span className="text-white/50 text-sm">From</span>
                      <p className="text-2xl font-bold text-orange-500">
                        ${yacht.price.toLocaleString()}<span className="text-sm font-normal text-white/50">/day</span>
                      </p>
                    </div>
                    <Link
                      to={`/yachts/${yacht.id}`}
                      className="px-5 py-2.5 border border-orange-500 text-orange-500 text-sm font-medium rounded-lg hover:bg-orange-500 hover:text-white transition-all duration-300"
                    >
                      View Details
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default YachtsPage;
